export async function generateSalt(data) {
  const response = await this.post('/auth/salt', data);

  return response;
}

export async function create(data) {
  const response = await this.post('/auth', data);

  return response;
}

export async function update(params) {
  const response = await this.patch('/auth', params);

  return response;
}

export async function destroy(params) {
  const response = await this.deleteWithKeepalive('/auth', params);

  return response;
}

export async function ping() {
  // Background keep-alive: a failed ping must not trigger navigate-on-error
  // (it runs every 30s, so navigate(-1) would otherwise fire repeatedly).
  const response = await this.post('/auth/ping', {}, {}, { silent: true });

  return response;
}

export async function requestReauth() {
  // Tell the server a reauth prompt has started; the server (not the client) sets the deadline
  // by which a fresh login must arrive, else it kills the token itself. Silent: a failed call
  // must not trigger navigate-on-error, and the client reauth flow proceeds regardless.
  const response = await this.post('/auth/reauth', {}, {}, { silent: true });

  return response;
}
